import React from 'react';
import { COLOR_VARIANTS, CircleIcons, TYPOGRAPHY_VARIANT, Typography } from '@tajawal/ct-web-design-system';

// utils
import { buildTestId } from '@/utils/helpers.utils';

// styles
import Styled from './BaggageInfoItem.styled';

// Components
import { BaggageInfoTitle } from '@/app-common/components/BaggageInfoBox/components/BaggageInfoTitle/BaggageInfoTitle';

type BaggageInfoItemProps = {
  baggageText: Record<'primary' | 'secondary', string>;
  testIdPrefix: string;
  isIncluded?: boolean;
  baggageOptionsAvailable?: boolean;
  canBePurchasedInNextStep?: boolean;
  isChecked?: boolean;
  isExtra?: boolean;
  isUnderSeatBaggage?: boolean;
};

export function BaggageInfoItem({
  baggageText,
  isChecked,
  isExtra,
  isIncluded,
  testIdPrefix,
  canBePurchasedInNextStep,
  baggageOptionsAvailable = false,
  isUnderSeatBaggage = false,
}: BaggageInfoItemProps): JSX.Element {
  let testId = buildTestId(testIdPrefix, 'Baggage', isChecked ? 'Checked' : 'Cabin');
  if (isExtra) {
    testId = buildTestId(testIdPrefix, 'Baggage', 'Extra');
  }

  function getIcon(
    isIncluded: boolean,
    isExtra: boolean,
    baggageOptionsAvailable: boolean,
    canBePurchasedInNextStep: boolean
  ) {
    switch (true) {
      case canBePurchasedInNextStep:
        return <Styled.CircleIcon width="24" height="24" />;
      case baggageOptionsAvailable:
        return <CircleIcons.CheckBlue width="24" height="24" />;
      case isIncluded:
        return <Styled.CheckIcon $isExtra={isExtra} width="24" height="24" />;
      case !isIncluded:
        return <CircleIcons.CloseDark width="24" height="24" />;
      default:
    }
  }

  return (
    <Styled.BaggageItem data-testid={testId}>
      {getIcon(isIncluded, isExtra, baggageOptionsAvailable, canBePurchasedInNextStep)}
      <Styled.BaggageTextWrapper>
        <BaggageInfoTitle
          baggageText={baggageText?.primary}
          isUnderSeatBaggage={isUnderSeatBaggage}
          isIncluded={isIncluded}
        />
        {baggageText.secondary && (
          <Typography component="span" variant={TYPOGRAPHY_VARIANT.CAPTIONREG} color={COLOR_VARIANTS.GREYCHATEAU}>
            {baggageText.secondary}
          </Typography>
        )}
      </Styled.BaggageTextWrapper>
    </Styled.BaggageItem>
  );
}
